import { useQuery } from '@tanstack/react-query'
import { sortBySequenceNumber } from 'shared/lib/common-util'
import { QueryKeys } from '../../../key-registry'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { Document } from '../../document/models/types'
import { fetchConsignmentDocumentsV3 } from './http'

export async function fetchConsignmentDocuments(id: number, opts?: { signal?: AbortSignal }): Promise<Document[]> {
  const responses = await fetchConsignmentDocumentsV3({ consignmentId: id }, opts)
  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}

export function useFetchConsignmentDocuments(consignmentId: number | null) {
  return useQuery({
    queryKey: QueryKeys.consignmentDocument.byConsignmentId(consignmentId),
    enabled: !!consignmentId,
    queryFn: ({ signal }) => fetchConsignmentDocuments(consignmentId as number, { signal }),
  })
}
